import getPublicHeaders from '@/requests/common/getPublicHeaders';

interface FetchLibraryDataParams<T> {
  url: string;
  signal?: AbortSignal;
  transform: (data: unknown) => T | null;
}

export const fetchLibraryData = async <T>({
  url,
  signal,
  transform,
}: FetchLibraryDataParams<T>): Promise<T | null> => {
  try {
    const response = await fetch(url, {
      headers: getPublicHeaders(),
      signal,
    });
    if (!response.ok) return null;
    const data: unknown = await response.json();
    return transform(data);
  } catch {
    return null;
  }
};
